export default {
    SET_FUNDINGS (state, fundings) {
      state.fundings = fundings
    },
    SET_FUNDINGS_DETAIL (state, fundingsDetail) {
      state.fundingsDetail = fundingsDetail
    },
    SET_ADD_FUNDINGMODAL_STATUS (state, addFundingModal) {
      state.addFundingModal = addFundingModal
    },
    SET_COMPANIES (state, companies) {
      state.companies = companies
    },
    SET_COMPANY_NAMES (state, companyNames) {
      state.companyNames = companyNames
    },
    SET_EXPORT_TOTAL_COUNT (state, exportTotalCount) {
      state.exportTotalCount = exportTotalCount
    },
    SET_FUNDINGS_BY_RG (state, fundingsRG) {
      state.fundingsRG = fundingsRG
    }
}
